import { render, staticRenderFns } from "./NoticesDetails.vue?vue&type=template&id=2d674007&scoped=true&"
import script from "./NoticesDetails.vue?vue&type=script&lang=js&"
export * from "./NoticesDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoticesDetails.vue?vue&type=style&index=0&id=2d674007&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d674007",
  null
  
)

export default component.exports